import {IntegrationAuthorization} from './IntegrationDesign';
import {integrationActions} from "../../../store/actions/integrationAction";
import {connect} from "react-redux";
import {useEffect} from "react";

function GoogleLoginRedirect(props) {
    const {history, integration, getGoogleLoginLink, alert} = props;

    useEffect(() => {
        if (integration.selectedIntegration.name === "Google Ads") {
            getGoogleLoginLink();
        }
    }, [getGoogleLoginLink, integration?.selectedIntegration?.name]);

    useEffect(() => {
        if (integration?.google?.loginLink !== null) {
            document.location.href = integration?.google?.loginLink;
        }
    }, [integration?.google?.loginLink])

    useEffect(() => {
        if (alert.errorMsg !== "") {
            history.push({pathname: "/settings/integrations"});
        }
    }, [history, alert?.errorMsg])

    return <IntegrationAuthorization name="Google"/>;
}

const mapStateToProps = (state) => {
    return {
        integration: state.integration,
        alert: state.alert
    };
};

const mapDispatchToProps = {
    getGoogleLoginLink: integrationActions.getGoogleLoginLink
};

export default connect(mapStateToProps, mapDispatchToProps)(GoogleLoginRedirect);
